<!-- Summary Details Link: Redirect to Entity Management confirmation modal -->
<!-- Uses shared confirmation modal; on confirm/cancel emits for AngularJS host to handle redirect/close -->
<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="false"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (closed)="onCancel()">
</gtw-confirmation-modal>
